import { Box } from "@mui/material"
import { memo } from "react"
import { AttackPokemonData } from "../../../types/attack"
import { PokemonV2 } from "../../../pokemon/pokemon"
import { retCalc } from "../../../types/damage"
import DamageResultDetails from "../../../components/DamageResultDetails"

interface DisplayDamageCalcProps {
  attackPokemon: AttackPokemonData
  selectedPokemon: PokemonV2
  calculateDamage: (attackPokemon: AttackPokemonData, defensePokemon: PokemonV2) => string
  getDamageDetail: (attackPokemon: AttackPokemonData, defensePokemon: PokemonV2) => retCalc
  getMoveDisplayName: (move: any, pokemonId: number) => string
  getMoveDisplayPower: (move: any, pokemonId: number) => number | string
}

const DisplayDamageCalc = memo(function DisplayDamageCalc({
  attackPokemon,
  selectedPokemon,
  calculateDamage,
  getDamageDetail,
  getMoveDisplayName,
  getMoveDisplayPower
}: DisplayDamageCalcProps) {
  if (!attackPokemon.selectedMoveId || !selectedPokemon || !attackPokemon.selectedMove) {
    return null;
  }

  const damageString = calculateDamage(attackPokemon, selectedPokemon);
  const damageDetail = getDamageDetail(attackPokemon, selectedPokemon);

  return (
    <Box sx={{ flex: '1 1 280px', minWidth: '280px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pr: 0.25 }}>
      <DamageResultDetails
        move={attackPokemon.selectedMove}
        pokemonId={attackPokemon.pokemon.id}
        damageText={damageString}
        damageDetail={damageDetail}
        getMoveDisplayName={getMoveDisplayName}
        getMoveDisplayPower={getMoveDisplayPower}
      />
    </Box>
  );
});

export default DisplayDamageCalc
